import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button } from 'react-daisyui';
import { pdfjs, Document, Page } from 'react-pdf';
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { useAuth } from "react-oidc-context";
import axios from 'axios';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
).toString();

const base_options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
    withCredentials: false,
  };

interface ViewReportModalProps {
  isOpen: boolean;
  participantId: number;
  studyId: number;
  onClose: () => void;
  onAction: () => void;
  downloadParticipantReport: () => void;
}

const ViewReportModal: React.FC<ViewReportModalProps> = ({
  isOpen,
  onClose,
  participantId,
  studyId,
  downloadParticipantReport
}) => {
  const [loading, setLoading] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [statusMessage, setStatusMessage] = useState('Loading PDF...');
  const memoPdfData = useMemo(() => (pdfData), [pdfData]);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
  }

  useEffect(() => {
    if(isOpen){
      axios.get(`/api/v1/study/${studyId}/view_individual_report/${participantId}/`, {responseType: 'blob'})
      .then((data)=>{
        setPdfData(data.data)
        setLoading(false)
      })
      .catch(async (err)=>{
        let errblob = err.response.data as Blob
        let errdata = await errblob.text()
        setLoading(false)
        setStatusMessage(`Error loading the pdf: ${errdata}`)
      });
    }else{
      setPdfData(null);
      setLoading(true)
      setStatusMessage('Loading PDF...')
    }
  }, [isOpen]);

  return (
    <Modal open={isOpen} className='w-11/12 max-w-7xl'>
      <Button
        id="viewReportModalDownloadButton"
        size="md"
        className="absolute right-6 top-6"
        onClick={() => downloadParticipantReport()}>
            <ArrowDownTrayIcon className="h-6 w-6"/>
      </Button>
      <Modal.Header className="font-bold">Report Preview - Participant #{participantId}</Modal.Header>

      <Modal.Body className=''>
        { isOpen && memoPdfData ?
          (
            <Document file={memoPdfData}
              onLoadSuccess={onDocumentLoadSuccess} options={base_options} onLoadError={(e)=>{console.error('PDF failed to load with error:', e)}}
              onError={(e)=>{console.error('PDF failed to load with error:', e)}}
              >
              <Page scale={1.4} className='flex justify-center' key={`page_2`} pageNumber={2} renderTextLayer={false} renderAnnotationLayer={false}/>
            </Document>
          )
          : <div>{statusMessage}</div>
        }
      </Modal.Body>

      <Modal.Actions>
        <Button id="viewReportModalCloseButton" type="button" disabled={loading} onClick={onClose}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ViewReportModal;
